import React from 'react'
import PropTypes from 'prop-types'
import { Card, Row, Col, Button, message } from 'antd'
import { PlayCircleOutlined, CopyOutlined } from '@ant-design/icons'
import ConnectWearables from '../../../asserts/images/connect-wearables-thumbnail.jpg'
import NutritionSignals from '../../../asserts/images/nutritional-signals-thumbnail.jpg'
import MedicalRelease from '../../../asserts/images/medical-release-forms-thumbnail.jpg'
import AssessmentResults from '../../../asserts/images/find-results.jpg'
import AssessmentReviewDeck from '../../../asserts/images/ar-deck.jpg'
import ApeironBlog from '../../../asserts/images/blogs.jpg'
import { loadUser } from '../../../utils/storage'
import { getRole } from '../../../utils/common'
import './faq.css'

const { Meta } = Card

const FAQContainer = () => {
  const faqs = [
    {
      id: 1,
      title: 'Connect Wearables',
      description:
        'Learn how to sync wearable devices and explore the synced data and health status.',
      thumbnail: ConnectWearables,
      videoUrl:
        'https://public-source.s3.us-west-2.amazonaws.com/marketing/Wearables_ExerciseSigs.webm'
    },
    {
      id: 2,
      title: 'Medical Release Forms',
      description:
        'Learn how to access and complete medical release forms for your health assessments',
      thumbnail: MedicalRelease,
      videoUrl:
        'https://public-source.s3.us-west-2.amazonaws.com/marketing/MedRelease.webm'
    },
    {
      id: 3,
      title: 'Nutrition Signals',
      description:
        'Learn how to interpret and analyze your nutritional biomarkers and health signals',
      thumbnail: NutritionSignals,
      videoUrl:
        'https://public-source.s3.us-west-2.amazonaws.com/marketing/NutritionSigs.webm'
    },
    {
      id: 4,
      title: 'Assessment Results',
      description: 'Learn how to find and view your assessment results.',
      thumbnail: AssessmentResults,
      videoUrl: 'https://public-source.s3.us-west-2.amazonaws.com/marketing/HowToFindResults.webm'
    },
    {
      id: 5,
      title: 'Assessment Review Deck and Files',
      description: 'Learn how to locate your assessment review deck and related files.',
      thumbnail: AssessmentReviewDeck,
      videoUrl: 'https://public-source.s3.us-west-2.amazonaws.com/marketing/HowToFindARDeck%26Files.webm'
    },
    {
      id: 6,
      title: 'Apeiron Blog and Resources',
      description: 'Learn how to access the Apeiron Blog and resources.',
      thumbnail: ApeironBlog,
      videoUrl: 'https://public-source.s3.us-west-2.amazonaws.com/marketing/ResourcesPage.webm'
    }
  ]

  const handleViewVideo = (videoUrl) => {
    window.open(videoUrl, '_blank')
  }

  const handleCopyClientLink = async () => {
    const clientLink = `${window.location.origin}/app/faq`
    try {
      await navigator.clipboard.writeText(clientLink)
      message.success('Client view link copied to clipboard!')
    } catch (err) {
      const textArea = document.createElement('textarea')
      textArea.value = clientLink
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      message.success('Client view link copied to clipboard!')
    }
  }

  const loggedInUser = loadUser()
  const userRole = loggedInUser ? loggedInUser.role : null
  const roleString = getRole(userRole)
  const showButton = roleString !== 'User'

  return (
    <div className="faq-container">
      {showButton && (
        <div className="faq-header">
          <Button
            type="primary"
            icon={<CopyOutlined />}
            onClick={handleCopyClientLink}
          >
            Copy Client View Link
          </Button>
        </div>
      )}
      <Row gutter={[16, 16]}>
        {faqs.map((faq) => (
          <Col xs={24} sm={12} md={12} lg={8} key={faq.id}>
            <Card
              hoverable
              className="faq-card"
              onClick={() => handleViewVideo(faq.videoUrl)}
              cover={
                <img
                  alt={faq.title}
                  src={faq.thumbnail}
                  className="faq-card-image"
                />
              }
              actions={[
                <PlayCircleOutlined
                  key="play"
                  onClick={(e) => {
                    e.stopPropagation()
                    handleViewVideo(faq.videoUrl)
                  }}
                  className="faq-play-icon"
                />
              ]}
            >
              <Meta
                title={
                  <span className="faq-title">
                    {faq.title}
                  </span>
                }
                description={
                  <div className="faq-meta-description">
                    <p className="faq-description">
                      {faq.description}
                    </p>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        handleViewVideo(faq.videoUrl)
                      }}
                    >
                      Watch Video
                    </a>
                  </div>
                }
              />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  )
}

FAQContainer.propTypes = {
  turnTo: PropTypes.func
}

export default FAQContainer
